const state = {
	overlay: document.querySelector('.leaving-site-overlay'),
	continueButton: document.querySelector('.leaving-site-overlay__continue'),
};

/**
 *
 * @param evt
 */
const closeOverlay = (evt) => {
	const closeOverlayButtons = state.overlay.querySelectorAll('.close-leaving-site-overlay');
	
	state.overlay.classList.remove('leaving-site-overlay--active');
	closeOverlayButtons.forEach((button) => {
		button.removeEventListener('click', closeOverlay);
	});
	
	setTimeout(() => {
		state.continueButton.href = '';
	}, 500);
};

/**
 *
 */
const initLeavingSiteOverlay = () => {
	window.addEventListener('load', () => {
		const openOverlayButtons = document.querySelectorAll('.open-leaving-site-overlay');
		
		if (openOverlayButtons.length > 0 && state.overlay) {
			
			openOverlayButtons.forEach((button) => {
				if (button.href && button.href !== '#' && button.href !== '') {
					button.addEventListener('click', (evt) => {
						evt.preventDefault();
						
						state.continueButton.href = button.href;
						
						const closeOverlayButtons = state.overlay.querySelectorAll('.close-leaving-site-overlay');
						closeOverlayButtons.forEach((button) => {
							button.addEventListener('click', closeOverlay);
						});
						
						state.overlay.classList.add('leaving-site-overlay--active');
					});
				}
			});
		}
	});
};

export default initLeavingSiteOverlay;
